import BankCanadaPaymentInfo from './BankCanadaPaymentInfo';

export default BankCanadaPaymentInfo;
export { BankCanadaPaymentInfoSchema } from './BankCanadaPaymentInfo.schema';
